import React, { useState, useEffect } from 'react';
import AjaxSpinner from 'components/commons/ajax_spinner';
import QuestionSummary from '../questions/question_summary';
import {user_api} from '../../commons/api';

export default function CommentedQuestions(props)
{
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, set_data] = useState(null);
    const user = props.username;

    useEffect(() =>
    {
        const fetchData = async () =>
        {
            const result = await user_api.get_commented_question_by_user(user);
            if(result.status && result.status === 'ok')
            {
                setIsLoaded(true);
                set_data(result);
            }
        }
        setIsLoaded(false);
        fetchData().catch(console.error);
    }, [user]);

    if (!isLoaded || data === null)
    {
        return <AjaxSpinner type='inline' />;
    }
    else return (
        <div className="questions-list-wrapper">
                {   data.commented.length ?
                    data.commented.map(item => (
                        <QuestionSummary key={item.id} item={item} />
                    ))
                    : <p>User has no comments</p>
                }
        </div>
    );
};
